import React from "react";
import config from "../config";

function Footer() {
  return (
    <footer className="sticky-footer bg-white">
      <div className="container my-auto">
        <div className="copyright text-center my-auto">
          {config.footerNotice}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
